package fr.frux.feature.treedetail

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

/**
 * Formatte un timestamp (millis) en date courte (jour/mois/année), fuseau local de l'appareil.
 *
 * Dupliqué à dessein depuis `formatHarvestDateTime` (feature-harvest-detail) : `feature-tree-detail`
 * ne doit pas dépendre d'une autre feature (#108), et la fiche arbre n'a besoin que de la date
 * (pas de l'heure) pour la section « Récoltes prévues » (#226).
 */
@OptIn(ExperimentalTime::class)
fun formatHarvestShortDate(epochMillis: Long): String {
    val dt = Instant.fromEpochMilliseconds(epochMillis).toLocalDateTime(TimeZone.currentSystemDefault())
    val day = dt.day.toString().padStart(2, '0')
    val month = dt.monthNumber.toString().padStart(2, '0')
    return "$day/$month/${dt.year}"
}

/** Jour du mois (« 12 ») pour la tuile-date de la section « Récoltes prévues ». */
@OptIn(ExperimentalTime::class)
fun harvestDayOfMonth(epochMillis: Long): String =
    Instant
        .fromEpochMilliseconds(epochMillis)
        .toLocalDateTime(TimeZone.currentSystemDefault())
        .day
        .toString()

private val monthAbbrevFr =
    listOf("JANV", "FÉVR", "MARS", "AVR", "MAI", "JUIN", "JUIL", "AOÛT", "SEPT", "OCT", "NOV", "DÉC")

/** Mois abrégé en capitales (« SEPT ») pour la tuile-date de la section « Récoltes prévues ». */
@OptIn(ExperimentalTime::class)
fun harvestMonthAbbrev(epochMillis: Long): String =
    monthAbbrevFr[
        Instant
            .fromEpochMilliseconds(epochMillis)
            .toLocalDateTime(TimeZone.currentSystemDefault())
            .monthNumber - 1,
    ]
